import React from 'react'
import { Field } from './Field'
import { FieldSchema } from 'components/Wizards/Wizard/Form/Types'
import { AutofillManager } from '../../Autofill/AutofillManager'

interface MobileFieldsSectionProps {
  fields: [string, FieldSchema][]
  setIsLoading?: (isLoading: boolean) => void
}
export const MobileFieldsSection: React.FC<MobileFieldsSectionProps> = ({ fields, setIsLoading }) => {
  if (!fields || fields.length === 0) {
    return null
  }

  return (
    <AutofillManager fieldNames={fields.map(([name]) => name)} setIsLoading={setIsLoading}>
      {fields.map(([name, schema]) => (
        <Field key={name} name={name} schema={schema} />
      ))}
    </AutofillManager>
  )
}
